var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v(_vm._s(_vm.label))]),_c('p',{staticClass:"control"},[_c('gmap-autocomplete',{staticClass:"input",attrs:{"value":_vm.locString,"placeholder":"Enter Address"},on:{"place_changed":_vm.setPlace}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }